import Validatable from '@/validator/Validatable';

export default class FilterBase extends Validatable {
  serializeForQueryString() {
    throw new Error('You have to implement the method doSomething!');
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static deserializeFromQueryString(filter, serialized) {
    throw new Error('You have to implement the method doSomething!');
  }
}
